import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import type { AuditLogEntry, MerkleProof } from '@aigftpwatch/shared';

export function useAuditLog(filters?: {
  entity_type?: string;
  entity_id?: number;
  user_email?: string;
  action?: string;
  page?: number;
  per_page?: number;
}) {
  const params = new URLSearchParams();
  if (filters?.entity_type) params.set('entity_type', filters.entity_type);
  if (filters?.entity_id) params.set('entity_id', String(filters.entity_id));
  if (filters?.user_email) params.set('user_email', filters.user_email);
  if (filters?.action) params.set('action', filters.action);
  if (filters?.page) params.set('page', String(filters.page));
  if (filters?.per_page) params.set('per_page', String(filters.per_page));
  const qs = params.toString() ? `?${params}` : '';

  return useQuery({
    queryKey: ['audit', filters],
    queryFn: () => api.getPaginated<AuditLogEntry>(`/audit${qs}`),
  });
}

export function useMerkleRoot() {
  return useQuery({
    queryKey: ['merkle', 'root'],
    queryFn: () => api.get<{ hash: string; count: number }>('/merkle/root').then((r) => r.data),
    refetchInterval: 60_000,
  });
}

export function useMerkleProof(auditLogId: number) {
  return useQuery({
    queryKey: ['merkle', 'proof', auditLogId],
    queryFn: () => api.get<MerkleProof>(`/merkle/proof/${auditLogId}`).then((r) => r.data),
    enabled: !!auditLogId,
  });
}
